export default "__VITE_ASSET__Bd1wx9LU__"